import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { TemplateMigrationPreviewProps } from './TemplateMigrationPreview.tsx';

export const TemplateMigrationPreviewLoader: LoadableType<TemplateMigrationPreviewProps> =
	LoadableAfterPaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-TemplateMigrationPreview" */ './TemplateMigrationPreview.tsx'
				)
			).TemplateMigrationPreview,
	});
